import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrow-zig-zag', 'IconArrowZigZag', [["path",{"d":"M6 20v-10l10 6v-12","key":"svg-0"}],["path",{"d":"M13 7l3 -3l3 3","key":"svg-1"}]]);